import { render } from "./Ribbon.vue?vue&type=template&id=5ed47e52&scoped=true"
import script from "./Ribbon.vue?vue&type=script&lang=js"
export * from "./Ribbon.vue?vue&type=script&lang=js"

import "./Ribbon.vue?vue&type=style&index=0&id=5ed47e52&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed47e52"]])

export default __exports__